import * as React from "react";
import { Link } from "@react-email/components";
import { emailTokens, getEmailBaseUrl } from "../tokens";
import { site } from "@/content/site";

export function EmailFooter() {
  const baseUrl = getEmailBaseUrl();
  const currentYear = site.foundedYear || 2026;

  return (
    <div
      style={{
        marginTop: "36px",
        paddingTop: "24px",
        borderTop: `1px solid ${emailTokens.colors.border}`,
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: emailTokens.colors.textMuted,
          lineHeight: "1.6",
          marginBottom: "12px",
        }}
      >
        <strong style={{ color: emailTokens.colors.textPrimary }}>Quto AI</strong> — Multilingual
        conversational AI agents for inbound and outbound calls, chat, and WhatsApp.
      </div>

      <div
        style={{
          fontSize: "11px",
          color: emailTokens.colors.textMuted,
          lineHeight: "1.6",
        }}
      >
        <Link
          href={baseUrl}
          style={{
            color: emailTokens.colors.textPrimary,
            textDecoration: "underline",
            marginRight: "12px",
          }}
        >
          Website
        </Link>
        <Link
          href={`${baseUrl}/privacy`}
          style={{
            color: emailTokens.colors.textMuted,
            textDecoration: "none",
            marginRight: "12px",
          }}
        >
          Privacy Policy
        </Link>
        <Link
          href={`${baseUrl}/terms`}
          style={{
            color: emailTokens.colors.textMuted,
            textDecoration: "none",
            marginRight: "12px",
          }}
        >
          Terms of Service
        </Link>
        <Link
          href={`${baseUrl}/contact`}
          style={{
            color: emailTokens.colors.textMuted,
            textDecoration: "none",
          }}
        >
          Contact Support
        </Link>
      </div>

      <div
        style={{
          fontSize: "11px",
          color: emailTokens.colors.textMuted,
          marginTop: "12px",
          lineHeight: "1.4",
        }}
      >
        © {currentYear} Quto AI. Zero-retention enterprise telephony & conversational AI.
      </div>
    </div>
  );
}
